import {useState} from 'react';
import TableFunction from '../../../../../components/table/TableFunction';
import {VIEW_TYPE} from '../../../../../enums/ViewType';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import CustomChip from '../../../../../components/CustomChip';
import {EMPTY_VALUES} from '../../../../../Apis/functions';
import {colors} from '../../../../../enums/colors';
import {statusBorderColor, statusColor, statusFontColor} from '../../../../../enums/statusColorEnum';
import {status} from '../../../../../enums/statusEnum';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import {
    DeleteIconsOptions,
    DetailsIconsOptions,
    UpdateIconsOptions,
} from '../../../../../components/buttons/IconButtons';
import routes from '../../../../../Routes/routes';
import {TABLES} from '../../../../../Apis/Tables';
import {SEARCH_MODEL} from '../../../../../components/table/Model/TableModel';
import {SimpleSearchWithId} from '../../../../../reduxToolkit/Search/SearchApi';
import {MATERIAL_TYPE} from "../Model/Model";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const EquipmentMaterialTableApp = (props) => {
    const {
        selectForDelete,
        setSelectForDelete,
        setDeleteModalShow,
        modified,
        setModified,
        setBodyForExport,
        contractorId,
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isAllChecked, setIsAllChecked] = useState(false);
    const navigate = useNavigate();
    const [tableId] = useState('tbl_emta_equipment_and_material');
    const [searchId] = useState('txt_emta_equipment_and_material');
    const [searchElement, setSearchElement] = useState('');
    const [searchResults, setSearchResults] = useState();
    const [simpleSearch, setSimpleSearch] = useState(false);
    const option = `${TABLES.EQUIPMENT_MATERIAL}`;

    /** Build Table Header */
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={50} classes='first_head'>
                {t('name')}
            </CustomTh>,
            <CustomTh tableId={tableId}>{t('code')}</CustomTh>,

            <CustomTh tableId={tableId}>{t('brand')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('model')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('serial_number')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('material_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('category')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('subcategory')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
        ];
    };

    /** Build Table Body */
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0) return { body: [], data: [] };

        const body = searchResults.content.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} tooltip={item?.name} fixed={true} left={50} classes='first-column'>
                        <span className='text-ellipsis'>{item?.name}</span>
                    </CustomTd>
                    <CustomTd tableId={tableId} tooltip={item?.code}>
                        <span className='text-ellipsis'>{item?.code}</span>
                    </CustomTd>

                    <CustomTd tableId={tableId} tooltip={item?.brand}>
                        <span className='text-ellipsis'> {item?.brand}</span>
                    </CustomTd>
                    <CustomTd tableId={tableId} tooltip={item?.model}>
                        <span className='text-ellipsis'> {item?.model}</span>
                    </CustomTd>
                    <CustomTd tableId={tableId} tooltip={item?.serialNumber}>
                        <span className='text-ellipsis'> {item?.serialNumber}</span>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={colors.primary100}
                            borderColor={colors.primary300}
                            fontColor={colors.primary700}
                            legend={t(MATERIAL_TYPE[item?.equipmentOwner]?.trans)}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.categoryName ? (
                            <CustomChip
                                background={colors.primary100}
                                borderColor={colors.primary300}
                                fontColor={colors.primary700}
                                legend={item.categoryName}
                            />
                        ) : (
                            EMPTY_VALUES.DEFAULT
                        )}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.subCategoryName ? (
                            <CustomChip
                                background={colors.primary100}
                                borderColor={colors.primary300}
                                fontColor={colors.primary700}
                                legend={item.subCategoryName}
                            />
                        ) : (
                            EMPTY_VALUES.DEFAULT
                        )}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[item?.statusId]}
                            borderColor={statusBorderColor[item?.statusId]}
                            fontColor={statusFontColor[item?.statusId]}
                            legend={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                            variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });

        return { body, data: searchResults.content };
    };
    //Returns the action buttons for each row item inside the table.
    const getActionsButtons = (row) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${row.id}`}>
                    <DropDownMenuItem
                        index={row.id}
                        handleClose={handleClose}
                        name={t('update')}
                        icon={<UpdateIconsOptions />}
                        url={`${routes.equipmentAndMaterial.update}${row?.id}`}
                    />
                    <DropDownMenuItem
                        index={row.id}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions />}
                        click={() => {
                            navigate(routes.equipmentAndMaterial.details + row?.id);
                        }}
                    />

                    <DropDownMenuItem
                        index={row.id}
                        handleClose={handleClose}
                        name={t('delete')}
                        fontColor='font-color-error-600'
                        icon={<DeleteIconsOptions className='icon-color-error-code-600' />}
                        click={() => {
                            setSelectForDelete([row.id]);
                            setDeleteModalShow(true);
                        }}
                    />
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            userId: contractorId,
            key: searchElement
        });
        // Save the request body for export purposes
        setBodyForExport(body);
        // Dispatch the search action and handle the response
        dispatch(SimpleSearchWithId({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    };

    /** Initialize TableFunction (pagination, search, etc.) */
    const {
        page,
        rowsPerPage,
        thead,
        tbody,
        pagination,
        handleClose,
        openMenu,
        handleMenuToggle,
        handleCheckboxChange,
        handleDeleteAll,
    } = TableFunction({
        data: searchResults,
        getThead,
        getTbody,
        view: VIEW_TYPE.LIST.name,
        labelRowsPerPage: 'equipment_material_per_page',
        fixedPagination: false,
        hasContainer: true,
        selectedList: selectForDelete,
        setSelectedList: setSelectForDelete,
        setIsAllChecked,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        isAllChecked,
        handleDeleteAll,
        navigate,
        searchElement,
        option,
        page,
        rowsPerPage,
        setSimpleSearch,
        setSearchElement,
        setSearchResults,
    };
};

export default EquipmentMaterialTableApp;
